import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=b8823eae&scoped=true&"
import script from "./FooterView.vue?vue&type=script&lang=js&"
export * from "./FooterView.vue?vue&type=script&lang=js&"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=b8823eae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8823eae",
  null
  
)

export default component.exports